export const SET_ARTICLE_EDIT_PERMISSION =
	'state.actions.set-article-edit-permission.SET_ARTICLE_EDIT_PERMISSION';

export type SetArticleEditPermissionAction = {
	type: typeof SET_ARTICLE_EDIT_PERMISSION;
	payload: {
		isEditable: boolean;
		articleId: string;
	};
};

export const setArticleEditPermission = (
	isEditable: boolean,
	articleId: string,
): SetArticleEditPermissionAction => ({
	type: SET_ARTICLE_EDIT_PERMISSION,
	payload: {
		isEditable,
		articleId,
	},
});
